// extracted by mini-css-extract-plugin
export default {"form":"ResetPassword_form__gvF7G","row":"ResetPassword_row__7XtdJ","center":"ResetPassword_center__RQ2dq","hrule":"ResetPassword_hrule__4TQAZ","page":"ResetPassword_page__xWvOP"};